// material-ui
import { Alert, Button, Fade, Grow, Slide } from '@mui/material';
import MuiSnackbar from '@mui/material/Snackbar';

// project import
// import IconButton from "./IconButton";
import { closeSnackbar, useGetSnackbar } from '../api/snackbar';
import { IconButton } from '@mui/material';

// assets
import { CloseOutlined } from '@ant-design/icons';

// animation function
function TransitionSlideLeft(props) {
    return <Slide {...props} direction="left" />;
}

function TransitionSlideUp(props) {
    return <Slide {...props} direction="up" />;
}

function TransitionSlideRight(props) {
    return <Slide {...props} direction="right" />;
}

function TransitionSlideDown(props) {
    return <Slide {...props} direction="down" />;
}

function GrowTransition(props) {
    return <Grow {...props} />;
}

// animation options
const animation = {
    SlideLeft: TransitionSlideLeft,
    SlideUp: TransitionSlideUp,
    SlideRight: TransitionSlideRight,
    SlideDown: TransitionSlideDown,
    Grow: GrowTransition,
    Fade
};

// ==============================|| SNACKBAR ||============================== //

const Snackbar = () => {
    const { snackbar } = useGetSnackbar();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        closeSnackbar();
    };
    return (
        <>
            {/* default snackbar */}
            {snackbar.variant === 'default' && (
                <MuiSnackbar
                    anchorOrigin={snackbar.anchorOrigin}
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    message={snackbar.message}
                    TransitionComponent={animation[snackbar.transition]}
                    action={
                        <>
                            <Button color="secondary" size="small" onClick={handleClose}>
                                UNDO
                            </Button>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} sx={{ mt: 0.25 }}>
                                <CloseOutlined />
                            </IconButton>
                        </>
                    }
                />
            )}
            {/* alert snackbar */}
            {snackbar.variant === 'alert' && (
                <MuiSnackbar
                    TransitionComponent={TransitionSlideUp}
                    //  TransitionComponent={animation[snackbar.transition]}
                    anchorOrigin={snackbar.anchorOrigin}
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    sx={{
                        marginRight: 8,
                        height: '50px', // Customize the height of the Snackbar
                        width: '100%', // Customize width if needed
                        '& .MuiSnackbar-root': {
                            maxHeight: '200px' // Control how much the Slide Down moves
                        }
                    }}
                >
                    <Alert
                        variant={snackbar.alert.variant}
                        color={snackbar.alert.color}
                        action={
                            <>
                                {snackbar.actionButton !== false && (
                                    <Button color={snackbar.alert.color} size="small" onClick={handleClose}>
                                        UNDO
                                    </Button>
                                )}
                                {snackbar.close && (
                                    <IconButton
                                        sx={{ mt: 0.25 }}
                                        size="small"
                                        aria-label="close"
                                        variant="contained"
                                        color={'#121926'}
                                        onClick={handleClose}
                                    >
                                        <CloseOutlined />
                                    </IconButton>
                                )}
                            </>
                        }
                        sx={{
                            border: snackbar.alert.color == 'success' ? '1px solid #69f0ae' : '1px solid #ff9999',
                            background:
                                snackbar.alert.color == 'success'
                                    ? 'linear-gradient(45deg, #69f0ae 30%, #eefdf3 90%)'
                                    : 'linear-gradient(45deg, #ff9999 30%, #f7eaea 90%)', // Linear gradient applied
                            color: '#121926', // Ensure the text color is readable over the gradient
                            fontWeight: '700',
                            ...(snackbar.alert.variant === 'outlined' && {
                                bgcolor: 'grey.0' // If outlined variant, adjust background
                            })
                        }}
                    >
                        {snackbar.message}
                    </Alert>
                </MuiSnackbar>
            )}
        </>
    );
};

export default Snackbar;
